/* 🤖 this file was generated by script */
export const wiconExclamation = {
  name: 'exclamation',
  data: `<svg viewBox="0 0 20 20"><path fill="currentColor" fill-rule="evenodd" d="M9 15a1 1 0 011-1 1 1 0 011 1 1 1 0 01-1 1 1 1 0 01-1-1z" clip-rule="evenodd"/><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M10.01 4.5v7.49"/></svg>`,
};
